import { render, staticRenderFns } from "./BestItemList.vue?vue&type=template&id=46122af7"
import script from "./BestItemList.vue?vue&type=script&lang=js"
export * from "./BestItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports